/* eslint-disable */
// Qintra Device Simulator — Device Database
const mk = (id, name, w, h, os, dpr, hz, opts) => ({ id, name, w, h, os, dpr, hz, ...(opts||{}) });

export const DEVICE_DB = {
  "android-phones": { label:"Android Phones", icon:"📱", brands: {
    Google: [
      mk("gp4","Pixel 4",393,830,"Android 11",2.75,90),
      mk("gp5","Pixel 5",393,851,"Android 12",2.75,90,{hole:true}),
      mk("gp6","Pixel 6",412,915,"Android 13",2.625,90,{hole:true}),
      mk("gp6p","Pixel 6 Pro",412,892,"Android 13",3.5,120,{hole:true}),
      mk("gp7","Pixel 7",412,915,"Android 13",2.625,90,{hole:true}),
      mk("gp7p","Pixel 7 Pro",412,892,"Android 13",3.5,120,{hole:true}),
      mk("gp8","Pixel 8",412,915,"Android 14",2.625,120,{hole:true}),
      mk("gp8p","Pixel 8 Pro",412,892,"Android 14",3.5,120,{hole:true}),
      mk("gp9","Pixel 9",393,852,"Android 15",3,120,{hole:true}),
      mk("gp9p","Pixel 9 Pro",412,892,"Android 15",3.5,120,{hole:true}),
      mk("gp9xl","Pixel 9 Pro XL",430,932,"Android 15",3.5,120,{hole:true}),
    ],
    Samsung: [
      mk("ss20","Galaxy S20",360,800,"Android 10",3,60,{hole:true}),
      mk("ss21","Galaxy S21",360,800,"Android 11",3,120,{hole:true}),
      mk("ss22","Galaxy S22",360,780,"Android 12",3,120,{hole:true}),
      mk("ss23","Galaxy S23",393,851,"Android 13",3,120,{hole:true}),
      mk("ss23u","Galaxy S23 Ultra",384,824,"Android 13",3.08,120,{hole:true}),
      mk("ss24","Galaxy S24",393,851,"Android 14",3,120,{hole:true}),
      mk("ss24p","Galaxy S24+",412,892,"Android 14",3,120,{hole:true}),
      mk("ss24u","Galaxy S24 Ultra",384,824,"Android 14",3.08,120,{hole:true}),
      mk("ss25","Galaxy S25",393,851,"Android 15",3,120,{hole:true}),
      mk("ss25u","Galaxy S25 Ultra",384,824,"Android 15",3.08,120,{hole:true}),
      mk("sa54","Galaxy A54 5G",393,851,"Android 13",2.625,120,{hole:true}),
      mk("sa34","Galaxy A34 5G",393,851,"Android 13",2.625,90,{hole:true}),
    ],
    OnePlus: [
      mk("op9p","OnePlus 9 Pro",412,919,"Android 13",3.5,120,{hole:true}),
      mk("op11","OnePlus 11",412,919,"Android 14",3.5,120,{hole:true}),
      mk("op12","OnePlus 12",412,919,"Android 14",3.5,120,{hole:true}),
      mk("op13","OnePlus 13",393,852,"Android 15",3,120,{hole:true}),
    ],
    Xiaomi: [
      mk("xm13u","Xiaomi 13 Ultra",393,852,"Android 13",3,120,{hole:true}),
      mk("xmrn12","Redmi Note 12 Pro",393,852,"Android 13",3,120,{hole:true}),
      mk("xm14","Xiaomi 14",393,852,"Android 14",3,120,{hole:true}),
      mk("xm15","Xiaomi 15",393,852,"Android 15",3,120,{hole:true}),
    ],
    Realme: [
      mk("rl12p","Realme 12 Pro+",393,852,"Android 14",3,120,{hole:true}),
      mk("rl11p","Realme 11 Pro+",393,852,"Android 13",3,120,{hole:true}),
    ],
    Nothing: [
      mk("nth1","Phone (1)",393,852,"Android 13",2.625,60,{hole:true}),
      mk("nth2","Phone (2)",393,852,"Android 14",2.625,120,{hole:true}),
      mk("nth3","Phone (3)",393,852,"Android 15",3,120,{hole:true}),
    ],
    Motorola: [
      mk("mto-e40","Moto Edge 40 Pro",412,892,"Android 13",3,165,{hole:true}),
      mk("mto-g84","Moto G84",393,852,"Android 13",2.625,120,{hole:true}),
    ],
    Oppo: [
      mk("oppo-f23","OPPO Find X7 Pro",412,919,"Android 14",3,120,{hole:true}),
      mk("oppo-r7","OPPO Reno 7 Pro",393,852,"Android 13",3,90),
    ],
    Vivo: [
      mk("vivo-v29","Vivo V29 Pro",393,852,"Android 13",3,120,{hole:true}),
      mk("vivo-x100","Vivo X100 Pro",412,919,"Android 14",3.5,120,{hole:true}),
    ],
    Sony: [
      mk("xe1v","Xperia 1 V",360,800,"Android 14",4,120),
      mk("xe5v","Xperia 5 V",360,780,"Android 14",3,120),
    ],
    Asus: [
      mk("rog8","ROG Phone 8 Pro",393,852,"Android 14",3,165,{hole:true}),
      mk("zf10","Zenfone 10",360,780,"Android 14",3,144,{hole:true}),
    ],
    Nokia:  [mk("nk-g60","Nokia G60 5G",393,852,"Android 13",2.625,120)],
    Huawei: [mk("hw-p60","Huawei P60 Pro",393,852,"HarmonyOS 4",3,120)],
    Honor:  [mk("hon-90","Honor 90 Pro",393,852,"Android 13",3,120,{hole:true})],
  }},
  "iphones": { label:"iPhones", icon:"🍎", brands: {
    Apple: [
      mk("ise3","iPhone SE 3rd Gen",375,667,"iOS 16",2,60),
      mk("ixr","iPhone XR",414,896,"iOS 15",2,60,{notch:true}),
      mk("i11","iPhone 11",414,896,"iOS 16",2,60,{notch:true}),
      mk("i12","iPhone 12",390,844,"iOS 17",3,60,{notch:true}),
      mk("i12pm","iPhone 12 Pro Max",428,926,"iOS 17",3,60,{notch:true}),
      mk("i13mini","iPhone 13 Mini",375,812,"iOS 17",3,60,{notch:true}),
      mk("i13pm","iPhone 13 Pro Max",428,926,"iOS 17",3,120,{notch:true}),
      mk("i14pm","iPhone 14 Pro Max",430,932,"iOS 17",3,120,{island:true}),
      mk("i15","iPhone 15",390,844,"iOS 18",3,60,{island:true}),
      mk("i15pm","iPhone 15 Pro Max",430,932,"iOS 18",3,120,{island:true}),
      mk("i16","iPhone 16",390,844,"iOS 18",3,60,{island:true}),
      mk("i16pm","iPhone 16 Pro Max",430,932,"iOS 18",3,120,{island:true}),
    ]
  }},
  "android-tablets": { label:"Android Tablets", icon:"📱", brands: {
    Samsung: [
      mk("tabs9","Galaxy Tab S9",1080,1600,"Android 13",2,120,{type:"tablet"}),
      mk("tabs9u","Galaxy Tab S9 Ultra",1280,1752,"Android 13",2,120,{type:"tablet"}),
    ],
    Google: [mk("pt","Pixel Tablet",1280,1920,"Android 14",2,60,{type:"tablet"})],
    Xiaomi:  [mk("mipad6","Mi Pad 6",1280,1600,"Android 13",2,144,{type:"tablet"})],
  }},
  "ipads": { label:"iPads", icon:"🍎", brands: {
    Apple: [
      mk("ipadmini6","iPad Mini 6",744,1133,"iOS 16",2,60,{type:"tablet"}),
      mk("ipadair5","iPad Air 5",820,1180,"iOS 17",2,60,{type:"tablet"}),
      mk("ipadpro11","iPad Pro 11in",834,1194,"iOS 17",2,120,{type:"tablet"}),
      mk("ipadpro13","iPad Pro 12.9in",1024,1366,"iOS 17",2,120,{type:"tablet"}),
      mk("ipad10","iPad 10th Gen",820,1180,"iOS 17",2,60,{type:"tablet"}),
    ]
  }},
  "win-laptops": { label:"Windows Laptops", icon:"💻", brands: {
    Generic: [
      mk("wl-1366","Laptop 1366x768",1366,768,"Windows 11",1,60,{type:"laptop"}),
      mk("wl-1920","Laptop 1920x1080",1920,1080,"Windows 11",1,60,{type:"laptop"}),
      mk("wl-2560","Laptop 2560x1440",2560,1440,"Windows 11",1.5,60,{type:"laptop"}),
    ],
    Dell: [
      mk("dx15","Dell XPS 15",1920,1200,"Windows 11",1,60,{type:"laptop"}),
      mk("dx13","Dell XPS 13",1920,1200,"Windows 11",1,60,{type:"laptop"}),
    ],
    HP:     [mk("hpeb","HP EliteBook 840",1920,1080,"Windows 11",1,60,{type:"laptop"})],
    Lenovo: [mk("tpx1","ThinkPad X1 Carbon",2560,1600,"Windows 11",2,60,{type:"laptop"})],
    Surface:[mk("sfp9","Surface Pro 9",2880,1920,"Windows 11",2,120,{type:"laptop"})],
  }},
  "macos": { label:"macOS", icon:"🍏", brands: {
    Apple: [
      mk("ma13m3","MacBook Air 13in M3",1280,832,"macOS Sequoia",2,60,{type:"laptop"}),
      mk("ma15m3","MacBook Air 15in M3",1366,878,"macOS Sequoia",2,60,{type:"laptop"}),
      mk("mp14","MacBook Pro 14in",1512,982,"macOS Sonoma",2,120,{type:"laptop"}),
      mk("mp16","MacBook Pro 16in",1728,1117,"macOS Sequoia",2,120,{type:"laptop"}),
      mk("imac24","iMac 24in",2240,1260,"macOS Sequoia",2,60,{type:"desktop"}),
    ]
  }},
  "desktop": { label:"Desktop", icon:"🖥", brands: {
    Generic: [
      mk("d-800","800x600 Legacy",800,600,"Generic",1,60,{type:"desktop"}),
      mk("d-1024","1024x768 XGA",1024,768,"Generic",1,60,{type:"desktop"}),
      mk("d-1366","1366x768 HD",1366,768,"Generic",1,60,{type:"desktop"}),
      mk("d-fhd","1920x1080 Full HD",1920,1080,"Generic",1,60,{type:"desktop"}),
      mk("d-qhd","2560x1440 QHD",2560,1440,"Generic",1,60,{type:"desktop"}),
      mk("d-4k","3840x2160 4K",3840,2160,"Generic",2,60,{type:"desktop"}),
      mk("d-uw","3440x1440 Ultrawide",3440,1440,"Generic",1,144,{type:"desktop"}),
    ]
  }},
  "large-screens": { label:"Large Screens", icon:"📺", brands: {
    Generic: [
      mk("tv-fhd","Smart TV 1080p",1920,1080,"SmartTV OS",1,60,{type:"desktop"}),
      mk("tv-4k","Smart TV 4K",3840,2160,"SmartTV OS",2,60,{type:"desktop"}),
    ]
  }},
  "foldables": { label:"Foldables", icon:"📱", brands: {
    Samsung: [
      mk("fold5c","Z Fold 5 Cover",373,812,"Android 14",2.81,120,{fold:true}),
      mk("fold5o","Z Fold 5 Open",882,1010,"Android 14",2.81,120,{fold:true,type:"tablet"}),
      mk("flip5","Z Flip 5",360,780,"Android 14",3,120,{fold:true}),
    ],
    Google: [mk("gpfold","Pixel Fold",841,1080,"Android 14",2.38,120,{fold:true,type:"tablet"})],
    Motorola:[mk("razr24","Moto Razr 2024",360,780,"Android 14",3,144,{fold:true})],
  }},
};

export const SZ_PRESETS   = [320,360,375,390,393,412,414,430,540,720,768,820,912,1024,1280,1366,1440,1536,1680,1920,2560,3840];
export const BROWSERS     = ["Chrome","Safari","Firefox","Edge","Opera","Samsung Browser","Brave"];
export const NETWORKS     = ["WiFi","5G","4G LTE","3G","Slow 3G","2G","Offline"];
export const TOUCH_MODES  = [["tap","Tap"],["double-tap","Dbl Tap"],["long-press","Long Press"],["swipe","Swipe"],["pinch","Pinch"],["drag","Drag"]];
export const DEFAULT_DEV  = { id:"ss24", name:"Galaxy S24", brand:"Samsung", category:"android-phones", w:393, h:851, os:"Android 14", dpr:3, hz:120, hole:true };
